import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.82 24" {...props}><path data-name="Path 3093" d="M14.82 12l-12 12L0 21.18 9.16 12 0 2.82 2.82 0z" fill="#1791dd" /></svg>);